var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('iframe',{staticStyle:{"width":"100%","height":"750px","border":"none","display":"block"},attrs:{"src":"/map-view.html"}})])
}]

export { render, staticRenderFns }